const moneyOptions = {
  'symbol': '',
  'thousand': '.',
  'decimal': ',',
  'precision': 2
}

export default moneyOptions



// WEBPACK FOOTER //
// ./src/moneyOptions.js